module.exports = __webpack_public_path__ + "img/14_julia_d.219f5316.png";